module.exports = __webpack_public_path__ + "static/media/dz.29c9e0c5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/dz.svg
// module id = 1222
// module chunks = 0